export const SESSION_STORAGE_KEY = {
  PAYMENT_UPDATED: 'payment_updated',
} as const

export const LOCAL_STORAGE_KEY = {
  RENTERS_VIDEO: 'renters_video',
} as const

export const SESSION_STORAGE_VALUE = {
  TRUE: 'true',
} as const
